import { render } from "./ZyfwzList.vue?vue&type=template&id=cfe4b4ca&scoped=true&ts=true"
import script from "./zyfwzListHelper.ts?vue&type=script&lang=ts"
export * from "./zyfwzListHelper.ts?vue&type=script&lang=ts"

import "./ZyfwzList.vue?vue&type=style&index=0&id=cfe4b4ca&scoped=true&lang=css"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfe4b4ca"]])

export default __exports__